import EventEmitter from "events";

export class ClientEventEmitter extends EventEmitter {
    constructor() {
        super();
    }
}
